export const HEADERS = ['No.', 'Name', 'VAT', 'Fakturownia key', 'Actions'];
